import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import "@/styles/index.scss"; // global css
import "@/assets/theme/vintage"; // 引入echarts主题
import App from "./App";
import store from "./store";
import router, { constantRoutes } from "./router";

import { getButton } from "@/utils/changeRouter";

import "@/icons"; // icon
import "@/permission"; // permission control
import { VueJsonp } from "vue-jsonp"; // jsonp请求
import "@/utils/index";
import QueryExport from "@/components/QueryExport";
import moment from "moment";

Vue.prototype.$getButton = getButton;

// 全局节流
const on = Vue.prototype.$on;
Vue.prototype.$on = function(event, func) {
  let previous = 0;
  let newFunc = func;
  if (event === "click") {
    newFunc = function() {
      const now = new Date().getTime();
      if (previous + 1000 <= now) {
        func.apply(this, arguments);
        previous = now;
      }
    };
  }
  on.call(this, event, newFunc);
};
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui,按如下方式声明
Vue.component("QueryExport", QueryExport);
Vue.use(ElementUI);
Vue.use(VueJsonp);
Vue.prototype.$TMap_Key = "BSQBZ-FRN6J-WTVFC-KQUMJ-4SKBF-TTF4K"; // 腾讯地图Key
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  },
});
